import React, { useEffect } from 'react';

const SilentCallback: React.FC = () => {
  useEffect(() => {
    // This component runs in an iframe for silent Azure AD authentication
    const handleCallback = () => {
      try {
        // Check for id_token in URL fragment (implicit flow)
        const hash = window.location.hash.substring(1);
        const hashParams = new URLSearchParams(hash);
        
        const idToken = hashParams.get('id_token');
        const error = hashParams.get('error');
        const errorDescription = hashParams.get('error_description');

        if (idToken) {
          // Success - send token to parent window
          window.parent.postMessage({
            success: true,
            idToken: idToken
          }, 'http://localhost:3001');
        } else {
          // Error - notify parent of failure
          console.log('Silent Azure AD failed:', error, errorDescription);
          window.parent.postMessage({
            success: false,
            error: error,
            errorDescription: errorDescription
          }, 'http://localhost:3001');
        }
      } catch (err) {
        console.error('Silent callback error:', err);
        // Notify parent of failure
        window.parent.postMessage({
          success: false,
          error: 'callback_error',
          errorDescription: 'Failed to process silent authentication callback'
        }, 'http://localhost:3001');
      }
    };

    // Process callback immediately
    handleCallback();
  }, []);

  // This component should never be visible to the user
  return null;
};

export default SilentCallback;